<script setup lang="ts">
import type { TDepositProtectionContacts } from './types'
import { Phone, Globe, Mail, MapPin } from 'lucide-vue-next'

defineProps<{
  contacts: TDepositProtectionContacts
}>()
</script>

<template>
  <SidebarBlock variant="white">
    <div class="flex items-center gap-3">
      <figure class="rounded-lg border p-1">
        <NuxtImg :src="contacts.logo" :alt="contacts.title" class="h-14 w-14 min-w-14" />
      </figure>
      <div>
        <Heading tag="h2" class="h3 font-serif !text-base !leading-4">
          {{ contacts.title }}
        </Heading>
        <p class="mt-1 text-xs leading-3 text-gray-700">{{ contacts.officialTitle }}</p>
      </div>
    </div>

    <div class="mt-4 grid grid-cols-1 space-y-4">
      <div class="flex flex-col space-y-3 rounded-lg">
        <template v-for="phone in contacts.phones" :key="phone">
          <a
            :href="`tel:${phone.replace(/[^+\d]/g, '')}`"
            class="flex items-center gap-2 hover:text-blue-600"
          >
            <div class="ContactIcon">
              <Phone class="h-5 w-5" />
            </div>
            <span class="text-sm font-semibold leading-3">{{ phone }}</span>
          </a>
        </template>

        <a :href="`mailto:${contacts.email}`" class="flex items-center gap-2 hover:text-blue-600">
          <div class="ContactIcon">
            <Mail class="h-5 w-5" />
          </div>
          <span class="text-sm font-semibold leading-3">{{ contacts.email }}</span>
        </a>

        <a
          :href="contacts.website"
          class="flex items-center gap-2 hover:text-blue-600"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="ContactIcon">
            <Globe class="h-5 w-5" />
          </div>
          <span class="text-sm font-semibold leading-3">{{ contacts.website }}</span>
        </a>

        <div class="flex items-center gap-2">
          <div class="ContactIcon">
            <MapPin class="h-5 w-5" />
          </div>
          <span class="text-sm font-semibold leading-3">
            {{ contacts.address }}
          </span>
        </div>
      </div>
    </div>
  </SidebarBlock>
</template>
